import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dpt-list"
};
const _hoisted_2 = {
  class: "dep-type-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "dep-cate-list"
};
const _hoisted_5 = ["onClick"];
import { computed, ref, watch } from 'vue';
import { depCateTypes } from '@/constants/kpi';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'dep-cate-list',
  props: {
    count: {
      type: Number,
      default: -1
    },
    search: {
      type: String,
      default: ''
    },
    selectKeys: {
      type: Array,
      default: () => []
    },
    selectItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:selectKeys', 'update:selectItems', 'select'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      runAsync: getDepCateList
    } = fetchApi('kpi.depCate.getList');
    const selectDType = ref('0');
    const depCateRows = ref([]);
    const depCateMap = ref({});
    const listRows = computed(() => {
      return (depCateRows.value || []).filter(t => t.dType + '' === selectDType.value);
    });
    const emit = __emit;
    const props = __props;
    const selected = ref([]);
    const isSelected = computed(() => key => {
      return selected.value.findIndex(t => t.id === key) !== -1;
    });
    const compareKeys = (a, b) => {
      if (a === b) return true;
      if (a.length !== b.length) return false;
      const tmpA = a.slice();
      const tmpB = b.slice();
      tmpA.sort();
      tmpB.sort();
      for (let i = 0; i < tmpA.length; i++) {
        if (tmpA[i] !== tmpB[i]) return false;
      }
      return true;
    };
    watch(() => props.selectKeys, val => {
      const oldKeys = selected.value.map(t => t.id);
      if (!compareKeys(val, oldKeys)) {
        const rows = [];
        for (const k of val) {
          const item = depCateMap.value[k];
          if (!item) continue;
          rows.push(item);
        }
        selected.value = rows;
      }
    }, {
      immediate: true,
      deep: true
    });
    const compareItemArray = (oldArr, newArr) => {
      if (oldArr === newArr) return true;
      const currentItems = newArr.slice();
      const oldItems = oldArr.slice();
      currentItems.sort((a, b) => {
        return (a.id || '').localeCompare(b.id || '');
      });
      oldItems.sort((a, b) => {
        return (a.id || '').localeCompare(b.id || '');
      });
      if (currentItems.length !== oldItems.length) return false;
      for (let i = 0; i < currentItems.length; i++) {
        if (currentItems[i].id !== oldItems[i].id) return false;
      }
      return true;
    };
    watch(() => props.selectItems, val => {
      if (compareItemArray(selected.value, val)) return;
      selected.value = [...val];
    }, {
      immediate: true,
      deep: true
    });
    const loadData = async params => {
      const {
        count = -1,
        search = ''
      } = params || {};
      const {
        error,
        rows = []
      } = await getDepCateList({
        search,
        count
      });
      if (error) return;
      depCateMap.value = rows.reduce((prev, cur) => {
        prev[cur.id] = cur;
        return prev;
      }, {});
      depCateRows.value = rows;
    };
    const handleFilter = dType => {
      selectDType.value = dType + '';
    };
    const handleToggleSelect = item => {
      const rows = selected.value.slice();
      const idx = rows.findIndex(t => t.id === item.id);
      if (idx === -1) {
        rows.push(item);
      } else {
        rows.splice(idx, 1);
      }
      selected.value = rows;
      emit('select', item);
      const keys = rows.map(t => t.id);
      emit('update:selectKeys', keys);
      emit('update:selectItems', rows);
    };
    watch([() => props.count, () => props.search], val => {
      const [count, search] = val;
      loadData({
        count,
        search
      });
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depCateTypes), (item, idx) => {
        return _openBlock(), _createElementBlock("a", {
          key: idx,
          href: "javascript:void(0);",
          onClick: () => handleFilter(item.value),
          class: _normalizeClass({
            'dep-type-item': true,
            'select-dep-type': selectDType.value === item.value + ''
          })
        }, _toDisplayString(item.label), 11, _hoisted_3);
      }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRows.value, (item, idx) => {
        return _openBlock(), _createElementBlock("a", {
          key: idx,
          class: _normalizeClass({
            'dpt-item': true,
            'dpt-item-select': isSelected.value(item.id)
          }),
          href: "javascript:void(0)",
          onClick: () => handleToggleSelect(item)
        }, _toDisplayString(item.name), 11, _hoisted_5);
      }), 128))]), _cache[0] || (_cache[0] = _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "item-more"
      }, "更多", -1))]);
    };
  }
};